import http from './index.js'// 登录接口
// 登录接口
export const Login = (str) => http.post('/api/users/register', str)
// 获取项目列表
export const GetProjectList = (str) => http.post('/api/project/getProjectList', str)
// 刷新token
export const reToken = (str) => http.post('/api/users/updateToken', str)
// 获取项目详细
export const ProAreaList = (str) => http.post('/api/project/getAreaList', str)
// 获取区域第一个
export const AreaInfoFirst = (str) => http.post('/api/project/getAreaInfo', str)
// 获取区域详细
export const AreaInfo = (str) => http.post('/api/project/getAreaInfo', str)
// 获取地区设备列表
export const DeviceList = (str) => http.post('/api/project/getDeviceList', str)
// 获取设备数据
export const DeviceLog = (str) => http.post('/api/device/getDeviceLog', str)
// 添加地区
export const Area = (str) => http.post('/api/project/addArea', str)
// 修改地区
export const EArea = (str) => http.post('/api/project/editArea', str)
// 删除地区
export const DArea = (str) => http.post('/api/project/delArea', str)
// 获取项目设备列表
export const ProjectDev = (str) => http.post('/api/project/getProjectDev', str)
// 添加设备
export const addDev = (str) => http.post('/api/project/addDevice', str)
// 删除设备
export const delDev = (str) => http.post('/api/project/delDevice', str)
// 获取设备数据列表
export const DeviceLogList = (str) => http.post('/api/device/getDeviceLogList', str)
// 编辑设备
export const eDev = (str) => http.post('/api/project/editDevice', str)
// 获取感知设备
export const IpDeviceList = (str) => http.post('/api/project/getIpDeviceList', str)
// 获取区域数据
export const getALog = (str) => http.post('/api/project/getAreaLog', str)
// 获取品牌
export const getDevicebrand = (str) => http.post('/api/devicebrand/getDevicebrandList', str)
// 获取aqi
export const getAqi = (str) => http.post('/api/city/getCityAqi', str)
// 下载数据
export const download = (str) => http.post('/api/device/checklog', str)
// 新风控制
export const xf = (str) => http.post('/api/api/controlxf', str)
// 新风状态
export const AreaXF = (str) => http.post('/api/api/searchAreaXF', str)
// 智能
export const martmodel = (str) => http.post('/api/project/startsmartmodel', str)
// 智能状态
export const smartstatus = (str) => http.post('/api/project/getsmartmodel', str)
// 获取设备类型
export const DeviceType = (str) => http.post('/api/device/getDeviceType', str)
// 获取设备参数
export const DeviceParam = (str) => http.post('/api/device/getDeviceParams', str)
